import React from 'react';
import MyBlock404 from './components/block404';

export default class PageNotFound extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <MyBlock404 history={this.props.history} />;
  }
}
